export enum Tip {
  restaurant = 'restaurant',
  driver = 'driver'
}
